// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import { baseUrl } from "../static/util/domain";
import '../static/css/reset.css'


Vue.use(MintUI);
Vue.config.productionTip = false;

let baseURL = baseUrl;
// let baseURL = 'https://running.osports.cn/biqu';
// let baseURL = 'http://192.168.1.74:8080/biqu';

Vue.filter('imgUrl', src => {
  if(src && src.indexOf('http') == -1){
    src = baseURL + src;
  }
  return src;
});


//axios配置
axios.defaults.baseURL = baseURL;//是你的接口所在电脑的  ip地址
axios.defaults.timeout = 30000;

Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js